<!-- <template>
    <div class="btn-group">
                  <div class="btn-col">
                    <a href="#" class="btn btn-secondary-outline">
                      <span class="btn-txt"><span class="btn-icon icon-share"></span>Share</span>
                    </a>
                  </div>
                </div>
</template> -->

<template>
  <div class="btn-col" @click.prevent="toggleSharePopup">
    <a href="#" class="btn btn-secondary-outline">
      <span class="btn-txt"
        ><span class="btn-icon icon-share"></span>Share</span
      >
    </a>
  </div>
</template>

<script>
import { useAppStore } from "@/stores/app-store";
import { mapStores } from "pinia";

export default {
  name: "ShareButton",
  computed: {
    ...mapStores(useAppStore),
  },
  methods: {
    toggleSharePopup: function () {
      console.log("toggleSharePopup");
      this.appStore.showSharePopup = !this.appStore.showSharePopup;
    },
  },
};
</script>
